import { render, staticRenderFns } from "./SingleKgkpSelection.vue?vue&type=template&id=3185227f&"
import script from "./SingleKgkpSelection.vue?vue&type=script&lang=ts&"
export * from "./SingleKgkpSelection.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports